const state = {
  connection: null,
  conferenceSid: null,
  isCalling: false,
  callSid: null,
  callFrom: null
}

const getters = {
  connection (state) {
    return state.connection
  },
  conferenceSid (state) {
    return state.conferenceSid
  },
  isCalling (state) {
    return state.isCalling
  },
  callSid (state) {
    return state.callSid
  },
  callFrom (state) {
    return state.callFrom
  }
}

const mutations = {
  REMOVE_TWILIO_DEVICE (state) {
    state.connection = null
    state.conferenceSid = null
    state.isCalling = null
    state.callSid = null
    state.callFrom = null
  },
  SET_CONNECTION (state, connection) {
    state.connection = connection
  },
  REMOVE_CONNECTION (state) {
    state.connection = null
  },
  SET_CONFERENCE_ID (state, conferenceSid) {
    state.conferenceSid = conferenceSid
  },
  REMOVE_CONFERENCE_ID (state) {
    state.conferenceSid = null
  },
  SET_IS_CALLING (state, isCalling) {
    state.isCalling = isCalling
  },
  SET_CALL_SID (state, callSid) {
    state.callSid = callSid
  },
  SET_CALL_FROM (state, callFrom) {
    state.callFrom = callFrom
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
